export class ChartData {
  public labels: Array<string>;
  public datasets: Array<ChartDataset>;

  public constructor() {
    this.labels = new Array<string>();
    this.datasets = new Array<ChartDataset>();

    this.datasets.push(new ChartDataset());
  }
}

export class ChartDataset {
  public data: Array<number>;
  public backgroundColor: Array<string>;
  public hoverBackgroundColor: Array<string>;
  public label: string;

  public constructor() {
    this.data = new Array<number>();
    this.backgroundColor = new Array<string>();
    this.hoverBackgroundColor = new Array<string>();
  }
}
